export default __webpack_public_path__ + "static/media/KR_Hero6_2.d10224e4.png";